"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavMockService = void 0;
var NavMockService = /** @class */ (function () {
    function NavMockService() {
    }
    NavMockService.getActiveNav = function (path, list) {
        var _this = this;
        var tarId = '';
        list.map(function (item) {
            if (item.url && item.url == path)
                tarId = item.id;
            if (item.children && !tarId)
                tarId = _this.getActiveNav(path, item.children);
        });
        return tarId;
    };
    NavMockService.getMock = function () {
        var nav = [
            {
                id: '2',
                name: '销售方管理',
                icon: 'inbox',
                url: "/management",
                children: [
                    {
                        id: '2-1',
                        name: '机构管理',
                        url: '/management/organ'
                    },
                    {
                        id: '2-2',
                        name: '帐号管理',
                        url: '/management/accout'
                    },
                    {
                        id: '2-3',
                        name: '签约H5管理',
                        url: '/management/contrh'
                    },
                ]
            },
            {
                id: '3',
                name: '签约管理',
                icon: 'inbox',
                url: "/contract",
                children: [
                    {
                        id: '3-1',
                        name: '签约审核',
                        url: '/contract/review'
                    },
                    {
                        id: '3-2',
                        name: '签约结果',
                        url: '/contract/result'
                    },
                ]
            },
            {
                id: '4',
                name: '话术模板',
                icon: 'inbox',
                url: "/script",
                children: [
                    {
                        id: '4-1',
                        name: '话术管理',
                        url: '/script/script-management'
                    },
                ]
            },
            {
                id: '5',
                name: '测评模板',
                icon: 'inbox',
                url: "/evaluation",
                children: [
                    {
                        id: '5-1',
                        name: '题库管理',
                        url: '/evaluation/question-management'
                    },
                    {
                        id: '5-2',
                        name: '问卷管理',
                        url: '/evaluation/questionnaire-manage'
                    },
                ]
            },
            {
                id: '70',
                name: '产品管理',
                icon: 'inbox',
                url: "/home",
                children: [
                    {
                        id: '71',
                        name: '产品列表',
                        url: '/home/list'
                    },
                    // {
                    //     id:'72',
                    //     name : '发行产品列表',
                    //     url : '/home/issue'
                    // },
                    {
                        id: '73',
                        name: '子产品列表',
                        url: '/home/subproduct'
                    },
                    {
                        id: '74',
                        name: '受益级别列表',
                        url: '/home/income'
                    },
                    {
                        id: '75',
                        name: '发行方案列表',
                        url: '/home/programme'
                    },
                ]
            },
            {
                id: '80',
                name: '合同管理',
                icon: 'inbox',
                url: "/template",
                children: [
                    {
                        id: '81',
                        name: '合同模板',
                        url: '/home/template'
                    },
                    {
                        id: '82',
                        name: '要素因子',
                        url: '/home/element'
                    },
                ]
            },
            {
                id: '6',
                name: '系统管理',
                icon: 'inbox',
                url: "/user",
                children: [
                    {
                        id: '6-1',
                        name: '用户管理',
                        url: '/home/user-management'
                    },
                    {
                        id: '6-2',
                        name: '角色管理',
                        url: '/home/role-management'
                    },
                    {
                        id: '6-3',
                        name: '菜单管理',
                        url: '/home/menu-management'
                    },
                    {
                        id: '6-4',
                        name: '数据字典管理 ',
                        url: '/home/dictionary-management'
                    }, {
                        id: '6-5',
                        name: '权限管理',
                        url: '/home/permissions-management'
                    },
                ]
            },
            {
                id: '7',
                name: '投资者认证',
                icon: 'inbox',
                url: "/attestation",
                children: [
                    {
                        id: '7-1',
                        name: '认证管理',
                        url: '/attestation/attestation-management'
                    },
                ]
            },
        ];
        return nav;
    };
    return NavMockService;
}());
exports.NavMockService = NavMockService;
